import { Component, createMemo, Show } from 'solid-js'

import { ArrowLeftIcon, ArrowRightIcon } from 'icons'
import './style/pagination.scss'

type Props = {
    max_page: number
    current: number
    onChange: (page: number) => void
}

export const Pagination: Component<Props> = P => {
    const pages = createMemo(() => {
        let pages = new Set<number>()

        pages.add(0)
        pages.add(1)

        if (P.current < P.max_page && P.current > 0) {
            pages.add(P.current - 1)
            pages.add(P.current)
            pages.add(P.current + 1)
        }

        pages.add(Math.max(P.max_page - 1, 0))
        pages.add(P.max_page)

        let out: number[] = []
        let pp = Array.from(pages)
        for (let i = 0; i < pp.length; i++) {
            let p = pp[i]!
            if (p < 0 || p > P.max_page) continue
            out.push(p)

            if (i + 1 < pp.length && p + 1 < pp[i + 1]!) {
                out.push(-1)
            }
        }

        return out
    })

    return (
        <div class='cmp-pagination title_smaller'>
            <button
                class='icon'
                disabled={P.current <= 0}
                onclick={() => P.onChange(P.current - 1)}
            >
                <ArrowRightIcon />
            </button>

            {pages().map(i => (
                <Show when={i >= 0} fallback={<span>...</span>}>
                    <button
                        disabled={P.current === i}
                        onclick={() => P.onChange(i)}
                        title={(i + 1).toString()}
                        classList={{ active: P.current === i }}
                    >
                        {i + 1}
                    </button>
                </Show>
            ))}

            <button
                class='icon'
                disabled={P.current >= P.max_page}
                onclick={() => P.onChange(P.current + 1)}
            >
                <ArrowLeftIcon />
            </button>
        </div>
    )
}

export const NextAndPrev: Component<Props> = P => {
    return (
        <div class='cmp-pagination next-prev title_smaller'>
            <button
                class='icon'
                disabled={P.current <= 0}
                onclick={() => P.onChange(P.current - 1)}
            >
                صفحه قبل
            </button>

            <button
                class='icon'
                disabled={P.current >= P.max_page}
                onclick={() => P.onChange(P.current + 1)}
            >
                صفحه بعد
            </button>
        </div>
    )
}
